import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';

/**
 * Common service
 */
@Injectable({
  providedIn: 'root',
})
export class EwCommonService {

  private token: string;
  public replayUnsaved = new BehaviorSubject<boolean>(false);
  public replayChange(value){
    this.replayUnsaved.next(value)
  }
  constructor(private authenticationService: AuthenticationService,
    private httpClient:HttpClient,) {
      this.token = this.authenticationService.getUserAccessToken();
    }
  /**
   * Gets date time string from current date
   * @returns Date in string format
   */
  getCurrentDateTimeString() {
    return moment().utc().format('YYYY-MM-DD HH:mm:ss.SSS');
  }

  /**
   * Gets date time string from given date
   * @param date Date
   * @returns Date in string format
   */
  getDateTimeStringFromDate(date: Date) {
    return moment(date).utc().format('YYYY-MM-DD HH:mm:ss.SSS');
  }

  /**
   * add class to popup container for custom design
   * @param classname
   * @returns null
   */
  addPopupCustomClass(className: string = 'ew-bottom-right-dailog') {
    let popUpContainer = document.getElementsByClassName(
      'cdk-overlay-container'
    );
    if (popUpContainer.length) {
      popUpContainer[0].classList.add(className);
    }
  }

  /**
   * remove class from popup container for custom design
   * @param classname
   * @returns null
   */
  removePopupCustomClass(className: string = 'ew-bottom-right-dailog') {
    let popUpContainer = document.getElementsByClassName(
      'cdk-overlay-container'
    );
    if (popUpContainer.length) {
      popUpContainer[0].classList.remove(className);
    }
  }

  getYoutubeVideo( newId):Observable<any> {
    const apiKey : string = 'AIzaSyD7zn9WzGmE10doeLJcnqVxhzMu2s4tn-w';
    let url = 'https://www.googleapis.com/youtube/v3/videos?id='+ newId+'&part=contentDetails,snippet&key='+apiKey
    return this.httpClient.get<any>(url)
      .pipe(map((res) => {
        return res;
      }))
  }

  getviemosvideo(userId){
    let headers = new HttpHeaders()
    .set('Authorization', 'Bearer '+this.token)
    .set('Content-Type', 'application/json');
    let url ='https://vimeo.com/api/v2/video/'+userId+'/json'
    return this.httpClient.get<any>(url)
     .pipe(map((res) => {
        return res;
      }))
  }

  getVideoWista(wistiaId):Observable<any> {
    let headers = new HttpHeaders()
    .set('Authorization', 'Bearer  '+this.token )
    .set('Content-Type', 'application/json');
    let url = 'https://api.wistia.com/v1/medias/'+wistiaId+'.json'
    return this.httpClient.get<any>(url,{headers})
      .pipe(map((res) => {
        return res;
      }))
  }
}
